<template>
  <router-view v-if="this.$route.path!=='/report/achievement/accountAnalysis'"></router-view>
  <div class="accountAnalysis" v-else>
    <div class="page-title">账户分析</div>
    <div class="top">
      <div class="form clearfix" v-if="accountAnalysisListStatus">
        <el-form :inline="true" ref="queryForm" :model="queryForm" class="form" label-width="90px">
          <el-form-item label="日期范围" prop="date">
            <el-date-picker
              v-model="timeDate"
              type="daterange"
              @change="changeTime()"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="优化师" prop="optimizing" >
            <el-select v-model="queryForm.employeesId" placeholder="请选择优化师" clearable filterable @change="getAccountAnalysisList()">
              <el-option v-for="item in optimizingList" :key="item.employeeId" :label="item.employeeName" :value="item.employeeId"></el-option>
            </el-select>
          </el-form-item> -->
          <div class="screening-form clearfix">
            <el-form-item label="筛选">
              <el-select v-model="queryForm.productId" @change="getProjectList(), changeTime()" clearable placeholder="请选择产品">
                <el-option
                  v-for="item in productData"
                  :key="item.id"
                  :label="item.productName"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-model="queryForm.projectId" @change="getAccountList(), changeTime()" clearable placeholder="请选择项目">
                <el-option
                  v-for="item in projectData"
                  :key="item.id"
                  :label="item.projectName"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select class="accountSelect" v-model="queryForm.agentAccountIdList" @change="changeTime('account')" filterable multiple clearable collapse-tags placeholder="请选择投放账户">
                <el-option
                  v-for="item in accountData"
                  :key="item.agentAccountId"
                  :label="item.agentAccountName"
                  :value="item.agentAccountId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" label-width="8px">
              <el-button @click="resetForm" type="info">重置选项</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div class="account-info" v-if="selectAccountName!==''">已选账户：{{selectAccountName}}</div>
      </div>
      <!-- <div class="btn">
      </div> -->
    </div>
    <div class="charts-box" v-loading="chartsLoading">
      <!-- 折线图 -->
      <div class="left-lineCharts">
        <el-tabs v-model="lineChartsActive" @tab-click="changeLineChartsDate">
          <el-tab-pane label="消耗"></el-tab-pane>
          <el-tab-pane label="计划数"></el-tab-pane>
        </el-tabs>
        <histogram-charts
          style="width:100%;margin:auto;"
          chartsName="lineChartsData"
          chartsType='line'
          :showPercent="true"
          :chartsDate.sync="lineChartsData"
          :chartsXAxisData="lineChartsXAxisList"
          :chartsColor="chartsColor">
        </histogram-charts>
      </div>
      <!-- 饼图 -->
      <div class="right-pieCharts">
        <el-form :inline="true" :model="analysisPieParam" class="pieCharts-form form">
          <el-form-item label="">
            <el-select v-model="analysisPieParam.item" placeholder="请选择对比项" @change="changePieChartsDate" size="small">
              <el-option label="搜索计划消耗" :value="1"></el-option>
              <el-option label="空跑计划数" :value="2"></el-option>
              <el-option label="创意重复计划数" :value="3"></el-option>
              <el-option label="通过冷启动期计划数" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="占比">
            <el-select v-model="analysisPieParam.item" placeholder="请选择对比项" disabled size="small">
              <el-option label="全部计划消耗" :value="1"></el-option>
              <el-option label="在投计划数" :value="2"></el-option>
              <el-option label="在投计划数" :value="3"></el-option>
              <el-option label="日新建计划" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <histogram-charts
          style="width:100%;margin:auto;"
          chartsName="pieChartsData"
          chartsType='pie'
          :showPercent="true"
          :chartsDate.sync="pieChartsData"
          :chartsColor="pieChartsColor"
          :chartsTotalDate.sync="pieChartsTotalData">
        </histogram-charts>
      </div>
    </div>
    <div>
      <div class="accountAnalysisList-top">
        <p>详情数据</p>
        <el-button @click="showColDialog" icon="iconfont icon-zidingyiguanli-copy" size="medium" type="primary">
          自定义列
        </el-button>
      </div>
      <el-table
        @sort-change="changeSort"
        :key="itemKey"
        :data="allData.pageData"
        v-loading="tableLoading"
        :max-height="tabHeight"
        ref="table" class="roleTable" border style="width: 100%">
        <el-table-column v-for="(col,index) in allData.headerData" :fixed="col.fixed"
        :prop="col.dictValue" :label="col.dictName" :key="index" :sortable="col.orderField?'custom':false"
        :min-width="col.dictName==='账户名称'?'180px':'160px'">
        </el-table-column>
        <el-table-column label="操作" v-if="allData.pageData.length>0&&accountAnalysisListStatus" fixed="right">
          <template slot-scope="scope">
            <el-button @click="viewAccountDetails(scope.row)" type="text" v-if="scope.row.reportDate!='合计'">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging-box" v-if="pageTotal>0&&accountAnalysisListStatus">
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.pageNum"
          :page-sizes="[ 10, 20, 40, 80, 100]"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <!-- 自定义列对话框 -->
    <set-cols
      :colsDialogFlag.sync="colsDialogFlag"
      @dragEnd="dragEnd"
      :leftMenu="false"
      :listdata="listdata"
      :checkedList="checkedList"
      :editBtn="editBtn">
    </set-cols>
  </div>
</template>

<script>
// 公用
import { handleTime, getData } from '@/components/public'
import draggable from 'vuedraggable'
import setCols from './../../components/setCols'
// 图表
import histogramCharts from './../../components/echarts/histogramCharts'

export default {
  name: 'accountAnalysis',
  components: {
    draggable,
    setCols,
    histogramCharts
  },
  data() {
    return {
      tableLoading: false,
      itemKey: '', // 临时变量
      // 筛选参数
      queryForm: {
        agentAccountIdList: [],
        // employeesId: '',
        productId: '',
        projectId: '',
        platformType: parseInt(localStorage.platformType),
        pageNum: 1,
        pageSize: 10,
        orderName: '',
        timeEnd: '',
        timeStar: ''
      },
      timeDate: [handleTime(new Date(), 7), handleTime(new Date(), 1)],
      accountAnalysisList: [],
      pageTotal: 0, // 数据总条数
      optimizingList: [],
      // 日期选择区间
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      accountAnalysisListStatus: false,
      // 选择产品
      productData: [],
      // 选择项目
      projectData: [],
      // 选择投放账户
      accountData: [],
      // 表格数据
      allData: {
        headerData: [],
        pageData: []
      },
      // 自定义列对话框
      colsDialogFlag: false,
      editBtn: true, // 自定义列应用按钮显示隐藏
      // 勾选上的列表
      checkedList: [],
      listdata: [],
      tabHeight: null,
      // 图表数据
      allChartsData: {},
      chartsColor: ['#3acfb3', '#457fec', '#F3545D', '#FDAF4B', '#9E8DD4', '#5549e2', '#d64e8a'],
      chartsLoading: false,
      lineChartsActive: '0',
      lineChartsData: [],
      lineChartsXAxisList: [],
      // 饼图
      pieChartsColor: ['#fda600', '#457fec', '#3acfb3'],
      pieChartsData: [],
      analysisPieParam: {
        item: 1
      },
      pieChartsTotalData: []
    }
  },
  created () {
  },
  mounted () {
    this.accountAnalysisListStatus = this.checkPermission('accountAnalysis:accountAnalysisList')
    this.getPageData(this.$route.path)
  },
  watch: {
    $route (to) {
      this.getPageData(to.path)
    }
  },
  methods: {
    getPageData (routePath) {
      if (routePath === '/report/achievement/accountAnalysis') {
        if (this.accountAnalysisListStatus) {
          // this.getAccountAnalysisList()
          this.resetForm()
        }
        // this.getAccountAndOpList()
        this.getProductList()
      }
    },
    // 排序的方法 每次排序会触发
    changeSort(val) {
      console.log('changeSort', val)
      if (val.order === 'ascending') {
        this.queryForm.orderName = val.prop.replace(/([A-Z])/g, '_$1').toLowerCase() + ' asc'
      } else {
        this.queryForm.orderName = val.prop.replace(/([A-Z])/g, '_$1').toLowerCase() + ' desc'
      }
      this.getAccountAnalysisList()
    },
    // 选择时间获取表格数据
    changeTime (val) {
      this.queryForm.pageNum = 1
      this.getAccountAnalysisList()
      if (val === 'account') {
        this.getSelectAccountName()
      }
    },
    getAccountAnalysisList() { // 获取账户分析列表
      this.tableLoading = TextTrackCue
      this.queryForm.timeEnd = getData('end', this.timeDate)
      this.queryForm.timeStar = getData('star', this.timeDate)
      console.log(this.queryForm)
      // 图表
      this.$service.post('/api/accountAnalysis/accountAnalysisGraph', this.queryForm).then(res => {
        console.log(res)
        this.allChartsData = res.result
        this.changePieChartsDate()
        this.lineChartsActive = '0'
        this.changeLineChartsDate()
        this.chartsLoading = false
      }).catch(Err => {
        console.log(Err)
        this.chartsLoading = false
      })
      // 列表
      this.$service.post('/api/accountAnalysis/accountAnalysisList', this.queryForm).then(res => {
        // this.itemKey = Math.random() // 在这边给key赋随机值，刷新表格
        this.allData.headerData = res.result.headerData
        this.allData.pageData = res.result.pageData
        this.pageTotal = res.result.total
        if (this.pageTotal > 3) {
          this.updateTabHeight()
        } else {
          this.tabHeight = null
        }
        this.tableLoading = false
      }).catch(Err => {
        console.log(Err)
        this.tableLoading = false
      })
    },
    changePieChartsDate() {
      // 饼图
      const circularData = this.allChartsData.circularData
      console.log('changePieChartsDate', circularData)
      const index = this.analysisPieParam.item - 1
      const leftContrastItem = ['搜索计划消耗', '空跑计划数', '创意重复计划数', '通过冷启动期计划数']
      const leftCode = ['searchCost', 'wasteAdCount', 'repeatAdCount', 'bootAdCount']
      const totalContrastItem = ['全部计划消耗', '在投计划数', '在投计划数', '日新建计划']
      const totalCode = ['cost', 'totalOpenAdCount', 'totalOpenAdCount', 'newAdCount']
      // const leftData = circularData[leftCode[index]] || 0
      // const rightData = circularData[totalCode[index]] - circularData[leftCode[index]] || 0
      // const totalData = circularData[totalCode[index]] || 0
      let otherNum = circularData[totalCode[index]] - circularData[leftCode[index]]
      this.pieChartsData = ['', [{
        name: leftContrastItem[index],
        value: circularData[leftCode[index]] || 0
      }, {
        name: '其他',
        value: otherNum > 0 ? otherNum : 0
      }]]
      this.pieChartsTotalData = [{
        name: totalContrastItem[index],
        value: circularData[totalCode[index]] || 0
      }]
    },
    changeLineChartsDate() {
      // 折线图
      const lineDataWithDate = this.allChartsData.lineDataWithDate
      console.log('changeLineChartsDate', lineDataWithDate)
      console.log(this.lineChartsActive)
      this.lineChartsXAxisList = lineDataWithDate.map(item => { return item.reportDate })
      console.log(this.lineChartsXAxisList)
      let lineChartsData = []
      if (this.lineChartsActive === '0') {
        // 消耗
        lineChartsData = [{
          data: lineDataWithDate.map(item => { return item.feedCost }),
          name: '信息流计划消耗'
        }, {
          data: lineDataWithDate.map(item => { return item.searchCost }),
          name: '搜索计划消耗'
        }]
      } else if (this.lineChartsActive === '1') {
        // 计划数
        lineChartsData = [{
          data: lineDataWithDate.map(item => { return item.totalOpenAdCount }),
          name: '在投计划数'
        }, {
          data: lineDataWithDate.map(item => { return item.wasteAdCount }),
          name: '空跑计划数'
        }, {
          data: lineDataWithDate.map(item => { return item.newAdCount }),
          name: '新建计划数'
        }, {
          data: lineDataWithDate.map(item => { return item.repeatAdCount }),
          name: '创意重复计划数'
        }]
      }
      this.lineChartsData = lineChartsData
    },
    updateTabHeight() {
      let height = document.documentElement.clientHeight
      let offsetTop = this.$refs.table.$el.offsetTop
      this.$nextTick(() => {
        this.tabHeight = parseInt(height - offsetTop - 83) > 300 ? parseInt(height - offsetTop - 83) : 300
      })
    },
    getAccountAndOpList() { // 获取筛选列表
      this.$service.get('/api/accountAnalysis/accountAndOpList').then(res => {
        // console.log(res.result)
        // if (res.result.accountData.length > 0) {
        //   this.accountList = res.result.accountData
        // }
        // 优化师
        if (res.result.employeeData.length > 0) {
          this.optimizingList = res.result.employeeData
        }
      }).catch(Err => {
        console.log(Err)
      })
    },
    viewAccountDetails(item) { // 查看账户分析详情
      item.reportDate = item.reportDate.substring(0, 10)
      this.$router.push({
        path: '/report/achievement/accountAnalysis/accountDetails',
        query: {
          // info: this.$secret.Encrypt(item.accountName + '_' + item.agentAccountId + '_' + item.reportDate) //AES+base64加密传输
          info: item.reportDate + item.agentAccountId
        }
      })
      let infoForm = {
        accountName: item.accountName,
        agentAccountId: item.agentAccountId,
        reportDate: item.reportDate
      }
      sessionStorage.setItem(item.reportDate + item.agentAccountId, JSON.stringify(infoForm))
    },
    // 获取产品
    getProductList() {
      this.productData = []
      this.projectData = []
      this.accountData = []
      this.$service.post('/api/project/getProductList4Common').then(res => {
        if (res.result.length > 0) {
          this.productData = res.result
        }
      }).catch(Err => {
        console.log(Err)
      })
    },
    // 获取项目
    getProjectList() {
      this.queryForm.projectId = ''
      this.queryForm.agentAccountIdList = []
      if (this.queryForm.productId === '') {
        this.projectData = []
        this.accountData = []
      } else {
        this.$service.post('/api/project/getProjectList4Common', {
          productId: this.queryForm.productId
        }).then(res => {
          if (res.result.length > 0) {
            this.projectData = res.result
          } else {
            this.projectData = []
          }
        }).catch(Err => {
          console.log(Err)
        })
      }
    },
    // 获取账户
    getAccountList() {
      this.queryForm.agentAccountIdList = []
      if (this.queryForm.projectId === '') {
        this.accountData = []
      } else {
        this.$service.post('/api/adReport/getAccountList', {
          projectId: this.queryForm.projectId
        }).then(res => {
          this.accountData = res.result.accountData
          this.getSelectAccountName()
        }).catch(Err => {
          console.log(Err)
        })
      }
    },
    // 重置选项
    resetForm () {
      this.queryForm.timeStar = ''
      this.queryForm.timeEnd = ''
      this.queryForm.dateType = 1 // 日期维度
      this.queryForm.productId = ''
      this.queryForm.projectId = ''
      this.queryForm.agentAccountIdList = []
      // this.queryForm.employeesId = ''
      this.queryForm.searchName = ''
      this.queryForm.orderName = '' // 排序字段
      // 分页
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10 // 每页显示的数据条数
      this.itemKey = Math.random() // 在这边给key赋随机值，刷新表格
      // this.productData = []
      this.projectData = []
      this.accountData = []
      this.timeDate = [handleTime(new Date(), 7), handleTime(new Date(), 1)]
      this.getAccountAnalysisList()
    },
    /*
    * 自定义列的对话框
    */
    // 显示自定义列对话框
    showColDialog () {
      this.checkedList = [] // 清空选中的列
      this.$service.post('/api/accountAnalysis/getAccountAnalysisCustomColumnList').then(res => {
        this.listdata = res.result.columnData
        this.checkedList = res.result.columnOrderData
        this.colsDialogFlag = true
      }).catch(err => {
        console.log(err)
      })
    },
    // 点击确定，获取拖动排序的列表
    dragEnd () {
      let jsonData = {
        'columnDetailData': this.checkedList
      }
      this.$service.post('/api/accountAnalysis/applyAccountAnalysisCustomColumnData', jsonData).then(res => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.changeTime()
        }
      })
      // 隐藏对话框
      this.colsDialogFlag = false
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.getAccountAnalysisList()
    },
    // 切换分页
    handleCurrentChange (pageNum) {
      this.queryForm.pageNum = pageNum
      this.getAccountAnalysisList()
    },
    getSelectAccountName() {
      console.log('getSelectAccountName', this.accountData, this.queryForm.agentAccountIdList)
      if (this.accountData.length > 0) {
        let arr = []
        if (this.queryForm.agentAccountIdList.length > 0) {
          arr = this.accountData.filter(item => { return this.queryForm.agentAccountIdList.indexOf(item.agentAccountId) !== -1 })
        } else {
          arr = this.accountData
        }
        console.log(arr)
        this.selectAccountName = arr.map(item => { return item.agentAccountName }).join('，')
      } else {
        this.selectAccountName = ''
      }
    }
  },
  // 计算属性
  computed: {
  }
}
</script>

<style scoped lang="less">
  @import './../../styles/common/public.less';
  .accountAnalysis{
    /deep/ .roleTable {
    .el-table__fixed {
      z-index: 11;
    }
    .el-table__fixed-right {
      z-index: 11;
    }
  }
  .top{
    margin-top: -15px;
    .form{
      // width: 910px;
      margin-bottom: -10px;
      .el-form-item{
        height: 42px;
        margin-bottom: 15px;
      }
      /deep/ .el-select__tags .el-tag{
        max-width: 50%;
      }
      .el-date-editor{
        width: 350px;
      }
      .el-select,.el-input{
        width: 350px;
      }
      .screening-form{
        .el-select,.el-input{
          width: 177px;
        }
        .accountSelect,.el-input{
            width: 320px;
        }
      }
      .account-info{
        padding: 20px 30px;
        margin: 10px 0;
        background: #f5f5f5;
      }
    }
    .btn{
      // margin: 15px 0 0;
      margin-top: -10px;
      text-align:right;
    }
  }
  .charts-box{
    position: relative;
    margin: 20px 0 30px;
    /deep/ .pieCharts-form{
      padding: 10px 0;
      width: 366px;
      margin: auto;
      .el-form-item{
        margin: 0 5px 0;
        .el-select{
          width: 150px;
        }
        .el-input.is-disabled .el-input__inner{
          background: #fff;
          color: @fontColor;
          border-color: @borderColor;
        }
      }
    }
    .left-lineCharts{
      margin-right: 460px;
      overflow: hidden;
      /deep/ .el-tabs .el-tabs__header .el-tabs__nav-wrap .el-tabs__item{
        padding: 0 15px;
      }
    }
    .right-pieCharts{
      position: absolute;
      width: 460px;
      right: 0;
      top:0;
    }
  }
  .accountAnalysisList-top{
    display: flex;
    justify-content: space-between;
    p{
      font-size: 18px;
      font-weight: bold;
      line-height: 35px;
      span{
        margin-left: 10px;
        font-size: 14px;
        font-weight: normal;
        color: @red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/analyze/accountAnalysis.vue